import styled from "styled-components";

export const BodyContainer = styled.div<{ w: string; h?: string }>`
  width: ${props => props.w ? props.w : "90%"};
  flex: 1;
  overflow: auto;
  background-color: #F5F5F5;
  height: ${props => props.h ? props.h : props.theme.height};
`;
